/** Format clé commerciale : NXS-XXXX-XXXX-XXXX-XXXX (A-Z, 0-9). */
export const COMMERCIAL_KEY_PATTERN = /^NXS-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/;

export function normalizeCommercialKey(raw: string): string {
  return raw.trim().toUpperCase().replace(/\s+/g, '');
}

export function isValidCommercialKey(raw: string): boolean {
  return COMMERCIAL_KEY_PATTERN.test(normalizeCommercialKey(raw));
}
